export type Language = 'nl' | 'en';
export const LANGUAGES: readonly Language[] = ['nl', 'en'];

/**
 * Alle teksten van de app, per taal. Voeg een sleutel altijd in BEIDE talen toe:
 * i18n.test.ts controleert dat de sleutels en de {plaatsvervangers} overeenkomen.
 * Gebruik {naam} voor variabele delen en vul ze in met tf().
 */
export const TRANSLATIONS = {
  nl: {
    metaTitle: 'Museumkompas',
    metaDescription: 'Alle Museumkaart-musea op één kaart. Houd bij waar je bent geweest en wat je nog wilt zien. Een product van FerMaak.',
    appHeading: 'Museumkompas',

    analyticsTitle: 'Anonieme statistieken',
    analyticsAsk: 'Mag ik anoniem bijhouden hoe de app gebruikt wordt (bezoeken en duur)? Zo kan ik hem verbeteren.',
    analyticsDesc: 'Anoniem bezoek en gebruiksduur, om de app te verbeteren. Je gegevens in de app blijven op je toestel.',
    analyticsAllow: 'Toestaan',
    analyticsDeny: 'Niet nu',
    analyticsOn: 'Statistieken aan',
    analyticsOff: 'Statistieken uit',
    tabKaart: 'Kaart',
    tabBuurt: 'In de buurt',
    tabVoortgang: 'Voortgang',
    tabsLabel: 'Weergave kiezen',

    zoekLabel: 'Zoek een museum',
    zoekPlaceholder: 'Zoek museum of plaats',
    zoekGeen: 'Geen musea gevonden',
    zoekWissen: 'Zoekopdracht wissen',
    filterLabel: 'Toon op de kaart',
    filterAlles: 'Alles',
    filterNietBezocht: 'Nog niet geweest',
    filterWens: 'Wensenlijst',
    filterFav: 'Favorieten',
    filterBezocht: 'Bezocht',
    filterAantal: '{n} musea',
    mijnLocatie: 'Ga naar mijn locatie',
    kaartLaden: 'Kaart laden…',
    kaartBasisOffline: 'Vereenvoudigde kaart: de kaartondergrond is niet bereikbaar.',
    kaartLabel: 'Kaart met musea',

    bezocht: 'Bezocht',
    wens: 'Wensenlijst',
    fav: 'Favoriet',
    navigeer: 'Navigeer',
    website: 'Website',
    sluitPaneel: 'Paneel sluiten',
    eenBezoek: 'Bezocht op {datum}',
    meerBezoeken: '{n} bezoeken, laatst op {datum}',
    nogEenBezoek: 'Nog een bezoek',
    bronWikipedia: 'Bron: Wikipedia',
    beoordeling: '{score} van 5 op Google ({n} reviews)',
    prijsLabel: 'Normale entree {prijs}',
    reserverenLabel: 'Reserveer vooraf een tijdslot',
    kopieerAdres: 'Kopieer adres',
    toonOpKaart: 'Open in Google Maps',
    adresGekopieerd: 'Adres gekopieerd',
    afstand: '{km} km',
    bezochtToast: '{naam} gemarkeerd als bezocht',
    onbezochtToast: 'Bezoek aan {naam} verwijderd',
    bezoekToegevoegd: 'Bezoek toegevoegd',
    wensAanToast: 'Op je wensenlijst gezet',
    wensUitToast: 'Van je wensenlijst gehaald',
    favAanToast: 'Toegevoegd aan favorieten',
    favUitToast: 'Uit favorieten gehaald',

    cat_kunst: 'Kunst',
    cat_geschiedenis: 'Geschiedenis',
    cat_wetenschap: 'Natuur & wetenschap',
    cat_techniek: 'Techniek',
    cat_cultuur: 'Cultuur',

    buurtTitel: 'In de buurt',
    buurtUitleg: 'Zie welke musea het dichtst bij je zijn. Je locatie blijft op je toestel.',
    buurtKnop: 'Gebruik mijn locatie',
    buurtBezig: 'Locatie zoeken…',
    buurtGeweigerd: 'Je locatie is niet beschikbaar. Sta locatie toe in je browser, of zoek op de kaart.',
    buurtOokBezocht: 'Toon ook bezochte',
    buurtVernieuw: 'Locatie vernieuwen',
    buurtLeeg: 'Alles in de buurt heb je al gezien. Knap!',

    voortgangTitel: 'Jouw voortgang',
    bezochtVan: '{n} van {totaal} musea bezocht',
    bezochtVanKort: 'van {totaal} musea bezocht',
    statBezoeken: 'Bezoeken',
    statWensen: 'Op wensenlijst',
    statFavorieten: 'Favorieten',
    terugTitel: 'Terugverdiend',
    terugLabel: 'aan entree bespaard',
    terugKaart: 'Je kaart kostte {prijs}. Telt vanaf {datum}.',
    terugWinst: 'Je kaart is {x}× terugverdiend',
    terugNog: 'Nog {bedrag} tot je kaart terugverdiend is',
    terugZonderPrijs: '{n} bezoeken zonder bekende prijs tellen niet mee.',
    provinciesTitel: 'Per provincie',
    provincieRij: '{n} van {totaal}',
    badgesTitel: 'Badges',
    badgesAantal: '{n} van {totaal} behaald',
    deelWens: 'Deel mijn wensenlijst',
    wensLeeg: 'Zet eerst musea op je wensenlijst om ze te delen.',

    badge_eerste: 'Eerste stap',
    badge_eerste_uitleg: 'Je eerste museum bezocht',
    badge_tien: 'Op dreef',
    badge_tien_uitleg: '10 musea bezocht',
    badge_vijfentwintig: 'Kenner',
    badge_vijfentwintig_uitleg: '25 musea bezocht',
    badge_vijftig: 'Fanaat',
    badge_vijftig_uitleg: '50 musea bezocht',
    badge_honderd: 'Legende',
    badge_honderd_uitleg: '100 musea bezocht',
    badge_drieProvincies: 'Grensganger',
    badge_drieProvincies_uitleg: 'Musea in 3 provincies',
    badge_heelNederland: 'Heel Nederland',
    badge_heelNederland_uitleg: 'Musea in alle 12 provincies',
    badge_provincieCompleet: 'Provinciekampioen',
    badge_provincieCompleet_uitleg: 'Alle musea in één provincie',
    badge_kunstkenner: 'Kunstkenner',
    badge_kunstkenner_uitleg: '10 kunstmusea bezocht',
    badge_tijdreiziger: 'Tijdreiziger',
    badge_tijdreiziger_uitleg: '10 geschiedenismusea bezocht',
    badge_terugverdiend: 'Slimme koop',
    badge_terugverdiend_uitleg: 'Je kaart terugverdiend',
    badge_trouweBezoeker: 'Vaste gast',
    badge_trouweBezoeker_uitleg: 'Eén museum 3× bezocht',

    welkomTitel1: 'Welkom bij Museumkompas',
    welkomTekst1: 'Alle {n} musea die meedoen aan de Museumkaart staan op één kaart.',
    welkomTekst1Zonder: 'Alle musea die meedoen aan de Museumkaart staan op één kaart.',
    welkomTekst1b: 'Zoom in voor namen en tik op een museum voor een korte omschrijving, het adres en de route.',
    welkomTitel2: 'Houd bij waar je bent geweest',
    welkomTekst2: 'Markeer een museum als bezocht, zet het op je wensenlijst of maak het favoriet. Op de kaart zie je dat zo:',
    welkomTitel3: 'Haal meer uit je kaart',
    welkomExtraBuurt: 'In de buurt: de dichtstbijzijnde musea waar je nog niet was',
    welkomExtraVoortgang: 'Voortgang: hoeveel musea je per provincie hebt gezien',
    welkomExtraBadges: 'Badges voor mijlpalen, zoals musea in alle 12 provincies',
    welkomExtraTerug: 'Terugverdiend: wat je aan entree bespaart (vul je kaartprijs en ingangsdatum in via het menu)',
    welkomExtraDelen: 'Deel je wensenlijst met een link',
    welkomPrivacy: 'Alles wat je markeert blijft op dit toestel. Er is geen account nodig.',
    welkomStap: 'Stap {n} van {totaal}',
    welkomOverslaan: 'Overslaan',
    welkomVorige: 'Vorige',
    welkomVolgende: 'Volgende',
    welkomStart: 'Naar de kaart',
    uitlegKnop: 'Uitleg',
    kaartHulp: 'De dag dat je kaart is gekocht of voor het eerst is gebruikt. Een Museumkaart is 1 jaar geldig.',
    kaartGeldigTot: 'Geldig tot {datum}',
    kaartZonderDatum: 'Vul de ingangsdatum in en je krijgt een herinnering voordat je kaart verloopt.',
    kaartNogDagen: 'Nog {n} dagen geldig',
    kaartNogEenDag: 'Nog 1 dag geldig',
    kaartLaatsteDag: 'Vandaag is de laatste dag',
    kaartVerlopenOp: 'Verlopen op {datum}',
    kaartWensNog: 'Nog {n} musea op je wensenlijst. Plan ze voordat je kaart verloopt.',
    kaartWensGeen: 'Je wensenlijst is leeg.',
    kaartAgendaKnop: 'Zet herinnering in agenda',
    kaartAgendaOk: 'Agenda-bestand opgeslagen',
    kaartAgendaTitel: 'Museumkaart verloopt over 30 dagen',
    kaartAgendaVerlopen: 'Laatste dag van je Museumkaart',
    kaartAgendaUitleg: 'Bezoek nog je wensenlijst-musea in Museumkompas, of verleng je Museumkaart.',
    kaartGegevensKnop: 'Kaartgegevens invullen',
    kaartGegevensWijzig: 'Kaartgegevens wijzigen',
    kaartControle: 'Controleer de datum met je eigen kaart.',
    terugKaartZonder: 'Je kaart kostte {prijs}. Telt de laatste 12 maanden; vul je ingangsdatum in voor een exacte telling.',

    herinneringBinnenkort: 'Je Museumkaart verloopt over {n} dagen',
    herinneringMorgen: 'Je Museumkaart verloopt morgen',
    herinneringVandaag: 'Je Museumkaart verloopt vandaag',
    herinneringVerlopen: 'Je Museumkaart is verlopen op {datum}',
    herinneringBekijk: 'Bekijk',
    herinneringSluit: 'Herinnering sluiten',

    backupTitel: 'Back-up en herstel',
    backupUitleg: 'Je gegevens staan alleen op dit toestel. Maak af en toe een back-up, bijvoorbeeld voordat je een nieuwe telefoon neemt.',
    backupLaatst: 'Laatste back-up: {datum}',
    backupGeen: 'Nog geen back-up gemaakt',
    backupMaak: 'Back-up maken',
    backupCsv: 'Exporteer als CSV',
    backupHerstel: 'Terugzetten uit bestand',
    backupOpgeslagen: 'Back-up opgeslagen',
    csvOpgeslagen: 'CSV opgeslagen',
    importTitel: 'Terugzetten uit bestand',
    importUitleg: 'Kies een back-up (.json) of een CSV die je uit Museumkompas hebt geëxporteerd. In een CSV kun je zelf bezocht, wensenlijst of favoriet invullen met ja of nee.',
    importKies: 'Kies bestand',
    importSleep: 'of sleep het bestand hierheen',
    importBezig: 'Bestand controleren…',
    importFout: 'Dit bestand kan niet worden teruggezet: {reden}',
    importTeGroot: 'Het bestand is te groot (maximaal 2 MB).',
    importLeesFout: 'Het bestand kon niet worden gelezen.',
    importOverzicht: 'Gevonden: {bezocht} bezocht, {wens} op de wensenlijst, {fav} favorieten.',
    importOnbekend: '{n} regels verwijzen naar musea die niet (meer) in de lijst staan en worden overgeslagen.',
    importKaart: 'De kaartgegevens uit dit bestand worden ook overgenomen.',
    importSamen: 'Samenvoegen met huidige gegevens',
    importSamenUitleg: 'Behoudt wat je nu hebt en voegt het bestand eraan toe.',
    importOverschrijf: 'Bestaande gegevens overschrijven',
    importOverschrijfUitleg: 'Vervangt alles wat je nu hebt gemarkeerd. Je kunt dit ongedaan maken.',
    importAnnuleer: 'Annuleren',
    importKlaar: 'Gegevens teruggezet',
    legendaTitel: 'Legenda',
    legendaNiet: 'Nog niet bezocht',
    legendaGroep: 'Groep musea, de groene boog is het deel dat je bezocht',

    kaartTitel: 'Mijn Museumkaart',
    kaartPrijs: 'Prijs van je kaart (€)',
    kaartVanaf: 'Ingangsdatum',
    bronTitel: 'Over de gegevens',
    bronVoorbeeld: 'Proefversie met {n} voorbeeldmusea. Ligging en prijzen zijn bij benadering.',
    bronTekst: 'Bron: {bron}. Bijgewerkt op {datum}.',
    bronOnofficieel: 'Onofficieel. Niet verbonden aan Stichting Museumkaart. Kaart © OpenStreetMap-bijdragers, OpenFreeMap. Locaties en omschrijvingen deels via Wikidata, OpenStreetMap, PDOK en Wikipedia (CC BY-SA).',

    settingsTitle: 'Weergave',
    modeLight: 'Licht',
    modeDark: 'Donker',
    modeAuto: 'Automatisch',
    languageLabel: 'Taal',

    installTitle: 'Voeg toe aan beginscherm',
    installDesc: 'Open de app direct, ook offline.',
    installBtn: 'Installeer',
    installedBadge: 'Geïnstalleerd / App-modus actief',
    installStepIos1: "Tik onderin op 'Delen'",
    installStepIos2: "Kies 'Zet op beginscherm'",
    installGeneric: "Open het browsermenu en kies 'App installeren' of 'Toevoegen aan startscherm'.",

    offlineBanner: 'Offline: de app werkt gewoon door, je gegevens blijven bewaard.',
    backOnline: 'Weer online',
    updateAvailable: 'Nieuwe versie beschikbaar',
    updateNow: 'Vernieuwen',
    updateLater: 'Later',
    closeBtn: 'Sluiten',
    undo: 'Ongedaan maken',
    menuOpen: 'Menu openen',
    menuTitle: 'Menu',
    versionLabel: 'Versie {version}',
    versionBuild: 'build {build}',
    upToDate: 'Je hebt de nieuwste versie',

    sharePreviewTitle: 'Gedeelde wensenlijst',
    sharePreviewDesc: 'Iemand deelde {n} musea met je. Zet ze op je wensenlijst?',
    sharePreviewMeer: 'en nog {n}',
    shareAccept: 'Toevoegen',
    shareIgnore: 'Negeren',
    shareAppliedToast: '{n} musea op je wensenlijst gezet',
    shareInvalidToast: 'Deze link is ongeldig of beschadigd',
    shareCopiedToast: 'Link gekopieerd',
    shareFailedToast: 'Delen is niet gelukt',
    shareText: 'Mijn museum-wensenlijst ({n} musea)',
  },
  en: {
    metaTitle: 'Museumkompas',
    metaDescription: 'Every Museumkaart museum on one map. Track where you have been and what you still want to see. A product by FerMaak.',
    appHeading: 'Museumkompas',

    analyticsTitle: 'Anonymous statistics',
    analyticsAsk: 'May I anonymously track how the app is used (visits and duration)? It helps me improve it.',
    analyticsDesc: 'Anonymous visits and usage time, to improve the app. Your data in the app stays on your device.',
    analyticsAllow: 'Allow',
    analyticsDeny: 'Not now',
    analyticsOn: 'Statistics on',
    analyticsOff: 'Statistics off',
    tabKaart: 'Map',
    tabBuurt: 'Nearby',
    tabVoortgang: 'Progress',
    tabsLabel: 'Choose view',

    zoekLabel: 'Search for a museum',
    zoekPlaceholder: 'Search museum or town',
    zoekGeen: 'No museums found',
    zoekWissen: 'Clear search',
    filterLabel: 'Show on the map',
    filterAlles: 'All',
    filterNietBezocht: 'Not visited yet',
    filterWens: 'Wishlist',
    filterFav: 'Favourites',
    filterBezocht: 'Visited',
    filterAantal: '{n} museums',
    mijnLocatie: 'Go to my location',
    kaartLaden: 'Loading map…',
    kaartBasisOffline: 'Simplified map: the base map is unavailable.',
    kaartLabel: 'Map of museums',

    bezocht: 'Visited',
    wens: 'Wishlist',
    fav: 'Favourite',
    navigeer: 'Navigate',
    website: 'Website',
    sluitPaneel: 'Close panel',
    eenBezoek: 'Visited on {datum}',
    meerBezoeken: '{n} visits, last on {datum}',
    nogEenBezoek: 'Another visit',
    bronWikipedia: 'Source: Wikipedia',
    beoordeling: '{score} out of 5 on Google ({n} reviews)',
    prijsLabel: 'Regular admission {prijs}',
    reserverenLabel: 'Book a time slot in advance',
    kopieerAdres: 'Copy address',
    toonOpKaart: 'Open in Google Maps',
    adresGekopieerd: 'Address copied',
    afstand: '{km} km',
    bezochtToast: '{naam} marked as visited',
    onbezochtToast: 'Visit to {naam} removed',
    bezoekToegevoegd: 'Visit added',
    wensAanToast: 'Added to your wishlist',
    wensUitToast: 'Removed from your wishlist',
    favAanToast: 'Added to favourites',
    favUitToast: 'Removed from favourites',

    cat_kunst: 'Art',
    cat_geschiedenis: 'History',
    cat_wetenschap: 'Nature & science',
    cat_techniek: 'Technology',
    cat_cultuur: 'Culture',

    buurtTitel: 'Nearby',
    buurtUitleg: 'See which museums are closest to you. Your location stays on your device.',
    buurtKnop: 'Use my location',
    buurtBezig: 'Finding location…',
    buurtGeweigerd: 'Your location is unavailable. Allow location in your browser, or search the map.',
    buurtOokBezocht: 'Also show visited',
    buurtVernieuw: 'Refresh location',
    buurtLeeg: 'You have seen everything nearby. Well done!',

    voortgangTitel: 'Your progress',
    bezochtVan: '{n} of {totaal} museums visited',
    bezochtVanKort: 'of {totaal} museums visited',
    statBezoeken: 'Visits',
    statWensen: 'On wishlist',
    statFavorieten: 'Favourites',
    terugTitel: 'Paid back',
    terugLabel: 'saved on admission',
    terugKaart: 'Your card cost {prijs}. Counting from {datum}.',
    terugWinst: 'Your card has paid for itself {x}×',
    terugNog: '{bedrag} to go until your card has paid for itself',
    terugZonderPrijs: '{n} visits without a known price are not counted.',
    provinciesTitel: 'By province',
    provincieRij: '{n} of {totaal}',
    badgesTitel: 'Badges',
    badgesAantal: '{n} of {totaal} earned',
    deelWens: 'Share my wishlist',
    wensLeeg: 'Add museums to your wishlist first to share them.',

    badge_eerste: 'First step',
    badge_eerste_uitleg: 'Visited your first museum',
    badge_tien: 'On a roll',
    badge_tien_uitleg: '10 museums visited',
    badge_vijfentwintig: 'Connoisseur',
    badge_vijfentwintig_uitleg: '25 museums visited',
    badge_vijftig: 'Enthusiast',
    badge_vijftig_uitleg: '50 museums visited',
    badge_honderd: 'Legend',
    badge_honderd_uitleg: '100 museums visited',
    badge_drieProvincies: 'Border crosser',
    badge_drieProvincies_uitleg: 'Museums in 3 provinces',
    badge_heelNederland: 'All of the Netherlands',
    badge_heelNederland_uitleg: 'Museums in all 12 provinces',
    badge_provincieCompleet: 'Province champion',
    badge_provincieCompleet_uitleg: 'Every museum in one province',
    badge_kunstkenner: 'Art lover',
    badge_kunstkenner_uitleg: '10 art museums visited',
    badge_tijdreiziger: 'Time traveller',
    badge_tijdreiziger_uitleg: '10 history museums visited',
    badge_terugverdiend: 'Smart buy',
    badge_terugverdiend_uitleg: 'Your card has paid for itself',
    badge_trouweBezoeker: 'Regular',
    badge_trouweBezoeker_uitleg: 'One museum visited 3×',

    welkomTitel1: 'Welcome to Museumkompas',
    welkomTekst1: 'All {n} museums that take part in the Museumkaart on one map.',
    welkomTekst1Zonder: 'All museums that take part in the Museumkaart on one map.',
    welkomTekst1b: 'Zoom in to see names and tap a museum for a short description, the address and directions.',
    welkomTitel2: 'Keep track of where you have been',
    welkomTekst2: 'Mark a museum as visited, add it to your wishlist or make it a favourite. On the map it looks like this:',
    welkomTitel3: 'Get more out of your card',
    welkomExtraBuurt: 'Nearby: the closest museums you have not visited yet',
    welkomExtraVoortgang: 'Progress: how many museums you have seen per province',
    welkomExtraBadges: 'Badges for milestones, such as museums in all 12 provinces',
    welkomExtraTerug: 'Paid back: what you save on admission (enter your card price and start date in the menu)',
    welkomExtraDelen: 'Share your wishlist with a link',
    welkomPrivacy: 'Everything you mark stays on this device. No account needed.',
    welkomStap: 'Step {n} of {totaal}',
    welkomOverslaan: 'Skip',
    welkomVorige: 'Back',
    welkomVolgende: 'Next',
    welkomStart: 'Go to the map',
    uitlegKnop: 'How it works',
    kaartHulp: 'The day your card was bought or first used. A Museumkaart is valid for 1 year.',
    kaartGeldigTot: 'Valid until {datum}',
    kaartZonderDatum: 'Enter the start date and you will get a reminder before your card expires.',
    kaartNogDagen: '{n} days left',
    kaartNogEenDag: '1 day left',
    kaartLaatsteDag: 'Today is the last day',
    kaartVerlopenOp: 'Expired on {datum}',
    kaartWensNog: '{n} museums left on your wishlist. Plan them before your card expires.',
    kaartWensGeen: 'Your wishlist is empty.',
    kaartAgendaKnop: 'Add reminder to calendar',
    kaartAgendaOk: 'Calendar file saved',
    kaartAgendaTitel: 'Museumkaart expires in 30 days',
    kaartAgendaVerlopen: 'Last day of your Museumkaart',
    kaartAgendaUitleg: 'Visit the museums on your wishlist in Museumkompas, or renew your Museumkaart.',
    kaartGegevensKnop: 'Enter card details',
    kaartGegevensWijzig: 'Change card details',
    kaartControle: 'Check the date against your own card.',
    terugKaartZonder: 'Your card cost {prijs}. Counting the last 12 months; enter your start date for an exact count.',

    herinneringBinnenkort: 'Your Museumkaart expires in {n} days',
    herinneringMorgen: 'Your Museumkaart expires tomorrow',
    herinneringVandaag: 'Your Museumkaart expires today',
    herinneringVerlopen: 'Your Museumkaart expired on {datum}',
    herinneringBekijk: 'View',
    herinneringSluit: 'Dismiss reminder',

    backupTitel: 'Backup and restore',
    backupUitleg: 'Your data only lives on this device. Make a backup now and then, for example before you get a new phone.',
    backupLaatst: 'Last backup: {datum}',
    backupGeen: 'No backup made yet',
    backupMaak: 'Make a backup',
    backupCsv: 'Export as CSV',
    backupHerstel: 'Restore from file',
    backupOpgeslagen: 'Backup saved',
    csvOpgeslagen: 'CSV saved',
    importTitel: 'Restore from file',
    importUitleg: 'Choose a backup (.json) or a CSV you exported from Museumkompas. In a CSV you can fill in visited, wishlist or favourite with ja or nee.',
    importKies: 'Choose file',
    importSleep: 'or drag the file here',
    importBezig: 'Checking file…',
    importFout: 'This file cannot be restored: {reden}',
    importTeGroot: 'The file is too large (maximum 2 MB).',
    importLeesFout: 'The file could not be read.',
    importOverzicht: 'Found: {bezocht} visited, {wens} on the wishlist, {fav} favourites.',
    importOnbekend: '{n} rows refer to museums that are not (or no longer) in the list and will be skipped.',
    importKaart: 'The card details from this file will be applied too.',
    importSamen: 'Merge with current data',
    importSamenUitleg: 'Keeps what you have now and adds the file to it.',
    importOverschrijf: 'Overwrite existing data',
    importOverschrijfUitleg: 'Replaces everything you have marked now. You can undo this.',
    importAnnuleer: 'Cancel',
    importKlaar: 'Data restored',
    legendaTitel: 'Legend',
    legendaNiet: 'Not visited yet',
    legendaGroep: 'Group of museums, the green arc is the part you visited',

    kaartTitel: 'My Museumkaart',
    kaartPrijs: 'Price of your card (€)',
    kaartVanaf: 'Start date',
    bronTitel: 'About the data',
    bronVoorbeeld: 'Preview with {n} sample museums. Locations and prices are approximate.',
    bronTekst: 'Source: {bron}. Updated on {datum}.',
    bronOnofficieel: 'Unofficial. Not affiliated with Stichting Museumkaart. Map © OpenStreetMap contributors, OpenFreeMap. Locations and descriptions partly from Wikidata, OpenStreetMap, PDOK and Wikipedia (CC BY-SA).',

    settingsTitle: 'Appearance',
    modeLight: 'Light',
    modeDark: 'Dark',
    modeAuto: 'Automatic',
    languageLabel: 'Language',

    installTitle: 'Add to home screen',
    installDesc: 'Open the app instantly, even offline.',
    installBtn: 'Install',
    installedBadge: 'Installed / App mode active',
    installStepIos1: "Tap 'Share' at the bottom",
    installStepIos2: "Choose 'Add to Home Screen'",
    installGeneric: "Open the browser menu and choose 'Install app' or 'Add to home screen'.",

    offlineBanner: 'Offline: the app keeps working and your data stays saved.',
    backOnline: 'Back online',
    updateAvailable: 'New version available',
    updateNow: 'Refresh',
    updateLater: 'Later',
    closeBtn: 'Close',
    undo: 'Undo',
    menuOpen: 'Open menu',
    menuTitle: 'Menu',
    versionLabel: 'Version {version}',
    versionBuild: 'build {build}',
    upToDate: 'You have the latest version',

    sharePreviewTitle: 'Shared wishlist',
    sharePreviewDesc: 'Someone shared {n} museums with you. Add them to your wishlist?',
    sharePreviewMeer: 'and {n} more',
    shareAccept: 'Add',
    shareIgnore: 'Ignore',
    shareAppliedToast: '{n} museums added to your wishlist',
    shareInvalidToast: 'This link is invalid or damaged',
    shareCopiedToast: 'Link copied',
    shareFailedToast: 'Sharing failed',
    shareText: 'My museum wishlist ({n} museums)',
  },
} as const;

export type TranslationKey = keyof typeof TRANSLATIONS.nl;

/** Vertaalt een sleutel; ontbreekt hij in de gekozen taal, dan valt hij terug op Nederlands. */
export function t(lang: Language, key: TranslationKey): string {
  const table = TRANSLATIONS[lang] as Record<string, string>;
  return table[key] ?? TRANSLATIONS.nl[key];
}

/** Zoals t(), maar vult {plaatsvervangers} in. Onbekende plaatsvervangers blijven staan. */
export function tf(lang: Language, key: TranslationKey, vars: Record<string, string | number>): string {
  return t(lang, key).replace(/\{(\w+)\}/g, (match, name) => (name in vars ? String(vars[name]) : match));
}
